import React from "react";
import { Route, Routes } from "react-router-dom";
import RouteAnimation from "@msidentity/SISU/components/route-animation/fabric/route-animation-fabric";
import { AgreementViewRoute, FlowId, ViewId } from "@msidentity/SISU/constants/routing-constants";
import { getRouteFromViewId } from "@msidentity/SISU/utilities/routing-helper";
import { AgreementViewFabric } from "@msidentity/SISU/views";
import { UsernameRecoveryBlockedViewFabric } from "../views/blocked/fabric/username-recovery-blocked-view-fabric";
import { UsernameRecoveryChallengeViewFabric } from "../views/challenge/fabric/username-recovery-challenge-view-fabric";
import { CollectProofViewFabric } from "../views/collect-proof/fabric/username-recovery-collect-proof-view-fabric";
import { EnterCodeViewFabric } from "../views/enter-code/fabric/username-recovery-enter-code-view-fabric";
import { UsernameRecoveryInitialViewPickerFabric } from "../views/initial-view-picker/fabric/username-recovery-initial-view-picker-fabric";
import { PhoneSpeedbumpViewFabric } from "../views/phone-speedbump/fabric/username-recovery-phone-speedbump-view-fabric";
import { ResultsViewFabric } from "../views/results/fabric/username-recovery-results-view-fabric";
import { UsernameRecoverySelectAliasViewFabric } from "../views/select-alias/fabric/username-recovery-select-alias-view-fabric";

/**
 * The Username Recovery flow component
 * @returns An instance of this component
 */
export const UsernameRecoveryFlowFabric: React.FC = function UsernameRecoveryFlowFabric() {
  return (
    <Routes>
      <Route path="*" element={<UsernameRecoveryInitialViewPickerFabric />} />
      <Route
        path={getRouteFromViewId(ViewId.UsernameRecoveryCollect)}
        element={<CollectProofViewFabric />}
      />
      <Route
        path={getRouteFromViewId(ViewId.UsernameRecoveryPhoneSpeedbump)}
        element={<PhoneSpeedbumpViewFabric />}
      />
      <Route
        path={getRouteFromViewId(ViewId.UsernameRecoveryLegacyCode)}
        element={<EnterCodeViewFabric />}
      />
      <Route
        path={getRouteFromViewId(ViewId.Challenge)}
        element={<UsernameRecoveryChallengeViewFabric />}
      />
      <Route
        path={getRouteFromViewId(ViewId.UsernameRecoveryResult)}
        element={<ResultsViewFabric />}
      />
      <Route
        path={getRouteFromViewId(ViewId.UsernameRecoverySelectAlias)}
        element={<UsernameRecoverySelectAliasViewFabric />}
      />
      <Route
        path={getRouteFromViewId(ViewId.UsernameRecoveryBlocked)}
        element={<UsernameRecoveryBlockedViewFabric />}
      />
    </Routes>
  );
};

/**
 * A wrapper component for the routes defined for UsernameRecovery.
 * @returns An instance of this component
 */
export const UsernameRecoveryRoutesFabric: React.FC = function UsernameRecoveryRoutesFabric() {
  return (
    <RouteAnimation>
      <Route path="*" element={<UsernameRecoveryFlowFabric />} />
      <Route
        path={AgreementViewRoute}
        element={<AgreementViewFabric hostingFlow={FlowId.UsernameRecovery} />}
      />
    </RouteAnimation>
  );
};
